import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const phasesTableTooltips = TOOLTIPS_TEXTS.phasesTable;

export const PHASES_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const PHASES_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const PHASES_TABLE_ARCHIVED_CONFIG: TableSource = {
  displayedColumns: ['name', 'description', 'isVideo', 'options'],
  displayedTitles: ['Name', 'Description', 'Video', 'Actions'],
  columnsConfig: [{ sorting: true }, { sorting: true }, { sorting: true }, { sorting: false }],
  displayedTooltips: [
    phasesTableTooltips.name,
    phasesTableTooltips.description,
    phasesTableTooltips.video
  ],
  columnsWithTitle: ['description'],
  options: null,
  dataSource: []
};

export const PHASES_TABLE_CONFIG: TableSource = {
  displayedColumns: ['index', 'name', 'description', 'isVideo', 'options'],
  displayedTitles: ['Order', 'Name', 'Description', 'Video', 'Actions'],
  columnsConfig: [
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false }
  ],
  displayedTooltips: [
    phasesTableTooltips.order,
    phasesTableTooltips.name,
    phasesTableTooltips.description,
    phasesTableTooltips.video
  ],
  columnsWithTitle: ['description'],
  options: null,
  dataSource: []
};

export const DEFAULT_PHASES_TABLE_CONFIG: TableSource = {
  displayedColumns: ['index', 'name', 'description', 'assignedDivisions', 'isVideo', 'options'],
  displayedTitles: ['Order', 'Name', 'Description', 'Assigned Divisions', 'Video', 'Actions'],
  columnsConfig: [
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false }
  ],
  displayedTooltips: [
    phasesTableTooltips.order,
    phasesTableTooltips.name,
    phasesTableTooltips.description,
    phasesTableTooltips.assignedDivisions,
    phasesTableTooltips.video
  ],
  columnsWithTitle: ['description'],
  options: null,
  dataSource: []
};

export const DEFAULT_PHASES_TABLE_ARCHIVED_CONFIG: TableSource = {
  displayedColumns: ['name', 'description', 'assignedDivisions', 'isVideo', 'options'],
  displayedTitles: ['Name', 'Description', 'Assigned Divisions', 'Video', 'Actions'],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    phasesTableTooltips.name,
    phasesTableTooltips.description,
    phasesTableTooltips.assignedDivisions,
    phasesTableTooltips.video
  ],
  columnsWithTitle: ['description'],
  options: null,
  dataSource: []
};
